import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map,catchError } from 'rxjs/operators';
import { BaseService } from './base.service';

export interface Employee {
  agentCode: string,
  agentName: string,
  status: string,
  responseMessage: string,
  isSuccessful: boolean,
}

@Injectable({
  providedIn: 'root'
})
export class AgentvalidationService {

  constructor(private baseService: BaseService, private http: HttpClient) { 
    this.baseService.http = http;
  }


  GetAgentValidation(code: string): Observable<{ agentName: string; status: string } | null> {
    // Append the code query parameter to the URL
    const url = `${this.baseService.baseUrl}/VerificationService/GetAgencies?agnCode=${code}`;

    // Make the HTTP GET request with the query parameter
    return this.baseService.http.get<{ result: Employee }>(url, { headers: this.baseService.headers }).pipe(
      map(response => {
        const employee = response.result; // API returns a single employee object
        return employee ? { agentName: employee.agentName, status: employee.status } : null;
      })
    );
  }
}
